import * as types from './constants';
import { assignTabDataAndDispatch } from '../../actions';

export function setIsLoading(isLoading, tabIndex) {
  return assignTabDataAndDispatch(
    { type: types.SET_IS_LOADING, isLoading },
    tabIndex
  );
}
